import './Logo.scss';
import { ucFirst } from '../Utils/caseconverters';
import classNames from 'classnames';

function Logo({ colorTheme, titleFirstLine, titleSecondLine, smallLeft }) {
  return (
    <h1
      className={classNames(
        "Logo",
        `Logo--${ucFirst(colorTheme)}`, {
          "Logo--SmallLeft": smallLeft
        })}>
      <span data-text={titleFirstLine} className="Logo__FirstLine">
        {titleFirstLine}
      </span>
      <span data-text={titleSecondLine} className="Logo__SecondLine">
        {titleSecondLine}
      </span>
    </h1>
  );
}

Logo.defaultProps = {
  colorTheme: "",
  alignLeft: false,
};

export default Logo;
